import React, { useState } from "react";
import Modal from "react-modal";

import * as S from "./styles";
import Close from "assets/close-small.svg";
import Button from "../../Button";
import { PicturesModal } from "../PicturesModal";
import Input from "../../Input";
import { acceptPictures, denyPictures } from "services/ReportServices";
import ApprovalPicsModal from "../ApprovalPicsModal";
import { formatOccurrenceStatus } from "utils/treatOccurrenceStatus";
import AttachmentsGallery from "components/AttachmentsGallery";
import { IReport } from "interfaces/Report";
import { AutoComplete } from "components/Autocomplete";
import { IOccurrence } from "interfaces/Occurrence";

interface ModalProps {
  modalIsOpen: boolean;
  setIsOpen: (value: boolean) => void;
  occurrence: IOccurrence | undefined
  selectedReport: IReport | null
  setSelectedReport: (report: IReport) => void
}

export function PicturesReportModal({ modalIsOpen, setIsOpen, occurrence, selectedReport, setSelectedReport }: ModalProps) {
  const [approveInitialModal, setApproveInitialModal] = useState(false);
  const [description, setDescription] = useState("");
  const [picturesModal, setPicturesModal] = useState(false);

  function closeModal() {
    setIsOpen(false);
  }

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        contentLabel="Example Modal"
        contentElement={(props, children) => (
          <S.ModalContent {...props}>{children}</S.ModalContent>
        )}
        overlayElement={(props, contentElement) => (
          <S.ModalOverlay {...props}>{contentElement}</S.ModalOverlay>
        )}
      >
        <S.AutoCompleteContainer>
          <AutoComplete
            label="Selecione um pronta-resposta"
            placeholder="Selecione ou pesquise por nome..."
            isMulti={false}
            options={occurrence?.report}
            value={selectedReport}
            getOptionLabel={report => report?.superficialPoliceman?.name ?? report.policeman?.user?.name}
            onChange={report => setSelectedReport(report as IReport)}
          />
        </S.AutoCompleteContainer>

        {selectedReport && (
          <>
            <img
              src={Close}
              alt="fechar"
              onClick={closeModal}
              data-cy="close-pictures-report-modal"
              className="close-pictures-report-modal"
            />
            <S.MoreDetailsContent>
              <header>
                <p>Anexos da ocorrência</p>
                <S.OccurrenceStatus
                  variant={
                    occurrence?.status === "aguardando" ||
                      occurrence?.status === "aprovacao"
                      ? "aguardando"
                      : occurrence?.status === "andamento"
                        ? "andamento"
                        : "finalizado"
                  }
                >
                  {formatOccurrenceStatus(occurrence?.status)}
                </S.OccurrenceStatus>
              </header>
              <S.ReportContent>
                <S.AttachmentGalleryContainer>
                  <AttachmentsGallery
                    photoGallery={selectedReport?.attachments ?? []}
                    pictureHeight="7rem"
                    pictureWidth="7rem"
                    galleryContainerGridTemplateColumns="repeat(5, 1fr)"
                    galleryContainerHeight="100%"
                  />
                </S.AttachmentGalleryContainer>
              </S.ReportContent>
            </S.MoreDetailsContent>

            <S.Footer>
              <S.ButtonsContainer>
                <Button
                  title="Negar"
                  disabled={
                    !description ||
                    !!selectedReport?.description
                  }
                  onClick={async () => {
                    if (selectedReport && description && occurrence) {
                      await denyPictures(
                        selectedReport.id,
                        description,
                      );

                      window.location.reload();
                    }
                  }}
                />
                <Input
                  id="description"
                  name="description"
                  onChange={(event: React.ChangeEvent<HTMLInputElement>) =>
                    setDescription(event.target.value)
                  }
                  type="text"
                  placeholder="Porque está negando as fotos?"
                  required={true}
                  disabled={!(selectedReport?.status === "aprovacao")}
                />

                <Button
                  title="Aceitar"
                  disabled={!(selectedReport?.status === "aprovacao")}
                  onClick={async () => {
                    if (selectedReport) {
                      await acceptPictures(selectedReport.id);
                      window.location.reload();
                    }
                  }}
                />
              </S.ButtonsContainer>
            </S.Footer>
          </>
        )}

        {!selectedReport && (
          <S.NoSelectedReportContainer>
            <h2>Nenhum pronta-resposta selecionado. Selecione o pronta resposta para aceitar/negar as fotos.</h2>
          </S.NoSelectedReportContainer>
        )}
      </Modal>

      {selectedReport?.description && (
        <ApprovalPicsModal
          content="Aprovar a foto permitira que a ocorrência siga para o andamento, 
        já negar voltará para a fase de aguardando esperando uma nova foto do km inicial"
          modalIsOpen={
            occurrence!.status === "aprovacao-km-inicial" && approveInitialModal
          }
          accept={() => {
            acceptPictures(occurrence!.id);
          }}
          deny={() => {
            if (selectedReport) {
              denyPictures(
                selectedReport?.id,
                "foto de km inicial negada, tire outra por favor."
              );
            }
          }}
          setIsOpen={setApproveInitialModal}
          title="Deseja aprovar a foto de KM inicial"
        />
      )}

      {selectedReport?.attachments && (
        <PicturesModal
          modalIsOpen={picturesModal}
          images={selectedReport.attachments}
          setIsOpen={setPicturesModal}
        />
      )}
    </>
  );
}
